import { inicializarVueNoElemento } from './VueHooks'

export function toast(tipo, texto, opts = {}) {
    let html = document.createElement('div')
    html.innerHTML = `<alo-toast tipo="${tipo}" texto="${texto}"></alo-toast>`

    if (Array.isArray(opts)) opts = {}

    html.querySelector('alo-toast').setAttribute(':opts', JSON.stringify(opts))

    let toasts = ensureToastsContainer()
    toasts.appendChild(html)

    let vm = inicializarVueNoElemento(html)

    return () => {
        vm.$destroy()
        if (vm.$el && vm.$el.parentElement) {
            vm.$el.parentElement.removeChild(vm.$el)
        }
    }
}

window.toast = toast

export function ensureToastsContainer() {
    let toasts = document.body.querySelector('[data-toasts]')
    if (toasts) return toasts

    toasts = document.createElement('div')
    toasts.setAttribute('data-toasts', 'true')
    toasts.className =
        'pointer-events-none fixed top-0 left-0 mt-4 w-full flex flex-col items-center justify-center z-50 space-y-2'

    document.body.appendChild(toasts)

    return toasts
}
